import React from 'react';
import { Form } from 'react-bootstrap';

type Props = {
  isRequired: boolean;
  onIsRequiredChange: (value: boolean) => void;
  requiredAt: string;
  onRequiredAtChange: (value: string) => void;
  overrideExisting: boolean;
  onOverrideExistingChange: (value: boolean) => void;
  showOverrideToggle: boolean;
  disabled?: boolean;
};

const AssignBulkMetadataFields: React.FC<Props> = ({
  isRequired,
  onIsRequiredChange,
  requiredAt,
  onRequiredAtChange,
  overrideExisting,
  onOverrideExistingChange,
  showOverrideToggle,
  disabled = false,
}) => {
  return (
    <div className="border rounded p-3 mb-3">
      <div className="fw-semibold small mb-3">Assignment options</div>

      <Form.Check
        type="switch"
        id="bulk-is-required"
        label="Mark as required"
        checked={isRequired}
        onChange={(e) => {
          const checked = e.target.checked;
          onIsRequiredChange(checked);
          if (!checked) onRequiredAtChange('');
        }}
        disabled={disabled}
        className="mb-2"
      />

      {isRequired && (
        <Form.Group className="mb-2">
          <Form.Label className="small mb-1">Required starting</Form.Label>
          <Form.Control
            type="date"
            size="sm"
            value={requiredAt}
            onChange={(e) => onRequiredAtChange(e.target.value)}
            disabled={disabled}
          />
        </Form.Group>
      )}

      {showOverrideToggle && (
        <Form.Check
          type="switch"
          id="bulk-override-existing"
          label="Override existing assignments (update required settings)"
          checked={overrideExisting}
          onChange={(e) => onOverrideExistingChange(e.target.checked)}
          disabled={disabled}
        />
      )}
    </div>
  );
};

export default AssignBulkMetadataFields;
